module.exports = __webpack_public_path__ + "img/time.51cfdf9a.svg";